import React from "react";
import {
  GhostArticle,
  FacebookShareButton,
  TwitterShareButton,
  EmailShareButton,
  ghost,
} from "@minerva-analytics/pantheon";
import { ThemeProvider } from "styled-components";
import {
  theme,
  ShareText,
  ShareContainer,
  ShareButtons,
} from "./Article.styles";
import { GHOST_API } from "../../ghost";
import { GRAY, RED, DARK_GRAY, BROWN } from "../../theme";

const colors = {
  body: GRAY,
  link: RED,
  title: DARK_GRAY,
  header: DARK_GRAY,
  backto: BROWN,
  published: DARK_GRAY,
  author: DARK_GRAY,
  readtime: BROWN,
};

const fonts = {
  title: "Abril Fatface",
  header: "Abril Fatface",
  backto: "Roboto Bold",
};

const domain = "https://www.cookingncocktails.com";

const Article = () => {
  const article = ghost.hooks.useSelectedArticle();

  return (
    <>
      <ThemeProvider theme={theme}>
        <GhostArticle
          ghostApi={GHOST_API}
          domain={domain}
          colors={colors}
          fonts={fonts}
        />
      </ThemeProvider>
      <ShareContainer>
        <ShareText>Share this article</ShareText>
        <ShareButtons>
          <FacebookShareButton
            appId="367029744636880"
            url={`https://${domain}/articles/${article.slug}`}
            description={article.title}
          />
          <TwitterShareButton
            body={`${article.title} - https://${domain}/articles/${article.slug}`}
            link={`https://${domain}/articles/${article.slug}`}
          />
          <EmailShareButton
            subject={`Check out: ${article.title}`}
            body={`Check out this article! https://${domain}/articles/${article.slug}`}
          />
        </ShareButtons>
      </ShareContainer>
    </>
  );
};

export default Article;
